import { inputBaseClasses, outlinedInputClasses } from "@mui/material"

export const wrapper = {
  p: { xs: 1.5, sm: 2 },
  mb: 2,
  borderRadius: 2,
  backgroundColor: "white",
  border: "1px solid rgba(0,0,0,0.23)",
  "&:hover": {
    border: "1px solid rgba(114, 151, 107, 1)",
  },
  position: "relative",
  [`&:has(.${inputBaseClasses.focused})`]: {
    border: "1px solid rgba(114, 151, 107, 1)",
  },
  [`&:has(.${inputBaseClasses.disabled})`]: {
    cursor: "not-allowed",
  },
}

export const inputWrapper = {
  mb: 1,
  gap: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}

export const inputBox = {
  flexGrow: 1,
  [`& .${inputBaseClasses.input}`]: {
    p: 0,
    fontSize: { xs: 18, md: 24 },
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    outline: 0,
    border: 0,
  },
  [`& .${inputBaseClasses.root}.${inputBaseClasses.focused}`]: {
    [`& .${outlinedInputClasses.notchedOutline}`]: {
      border: 0,
      outline: 0,
    },
  },
  [`& .${inputBaseClasses.disabled}`]: {
    cursor: "not-allowed",
  },
}

export const selectWrapper = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
}

export const selectBox = {
  minHeight: 42,
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: 1,
    p: 1,
    backgroundColor: "selectInputBackground",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: 0,
    outline: 0,
  },
  "&.MuiInputBase-root.Mui-focused": {
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiInputBase-input": {
      border: "1px solid black",
    },
  },
  [`& .MuiInputBase-input.Mui-disabled`]: {
    cursor: "not-allowed",
  },
}

export const selectIconStyle = {
  fontSize: { xs: 14, md: 16 },
}

export const maxText = {
  fontSize: 14,
  textDecoration: "underline",
  cursor: "pointer",
  textWrap: "nowrap",

  "&:hover": {
    color: "green",
  },
}

export const convertWrapper = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: { xs: 0.5, sm: 1 },
}

export const convertText = {
  fontSize: 13,
  flex: { xs: 0.5, sm: "unset" },
  lineHeight: "1.5rem",
  color: "gray63",
  textOverflow: "ellipsis",
  overflow: "hidden",
}

export const balanceWrapper = {
  display: "flex",
  flex: { xs: 1, sm: "unset" },
  gap: 0.5,
  flexWrap: "wrap",
  justifyContent: "end",
  alignItems: "center",
}

export const balanceAmount = {
  fontSize: { xs: 12, md: 13 },
  lineHeight: "1.5rem",
  fontWeight: 600,
  textAlign: "end",
}

export const convertedBalanceText = {
  fontSize: 12,
  color: "grey",
}

export const balanceText = {
  fontSize: { xs: 12, md: 13 },
  lineHeight: "1.5rem",
  color: "gray63",
}
